var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thank-you"},[_c('p',{staticClass:"heading--5"},[_vm._v("Thank you for registering!")]),_c('p',{staticClass:"body"},[_vm._v("Please check your email to activate your account.")])])
}]

export { render, staticRenderFns }